import * as serverReq from "./instrumentsCrud";
import {instrumentsSlice} from "./instrumentsSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = instrumentsSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  if (error?.message && error.message === "Cancel Request" ) return;
  dispatch(actions.instrumentNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.instrumentNotification({notification: null}));

/* Load Search Instruments Action */
export const searchInstruments = (query, limit = 10) => dispatch => {
  dispatch(actions.isLoading());
  serverReq.getSearchInstruments(query, limit)
            .then(({data}) =>  dispatch(actions.instrumentsFetched({ data })))
            .catch(errorHandler(dispatch));
};